<template>
  <p>Filtra tus usuarios aquí</p>

  <a-checkbox-group v-model:value="selectedAgentsStates" class="dashboard-checkbox-list">
    <ul class="list">
      <li v-if="!progressive" class="list__item waiting-color">
        <a-checkbox :value="EventManagement.Waiting">
          <div class="list__item-content">
            <span class="list__label">
              Esperando

              <a-tooltip title="Estado en el que el usuario espera llamada.">
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
            <span class="list__value"> {{ data.waiting }} </span>
          </div>
        </a-checkbox>
      </li>

      <li class="list__item ringing-color">
        <a-checkbox :value="EventManagement.Ringing">
          <div class="list__item-content">
            <span class="list__label">
              Timbrando

              <a-tooltip
                title="Estado en el que el usuario realiza una rellamada y timbra el teléfono del contacto."
              >
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
            <span class="list__value"> {{ data.ringing }} </span>
          </div>
        </a-checkbox>
      </li>

      <li class="list__item talking-color">
        <a-checkbox :value="EventManagement.Talking">
          <div class="list__item-content">
            <span class="list__label">
              Hablando

              <a-tooltip
                title="Estado en el que el usuario se encuentra en llamada con el contacto."
              >
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
            <span class="list__value"> {{ data.talking }} </span>
          </div>
        </a-checkbox>
      </li>

      <li class="list__item acw-color">
        <a-checkbox :value="EventManagement.Acw">
          <div class="list__item-content">
            <span class="list__label">
              ACW

              <a-tooltip
                title="Estado en el que el usuario se encuentra en llamada con el contacto."
              >
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
            <span class="list__value"> {{ data.awc }} </span>
          </div>
        </a-checkbox>
      </li>

      <li class="list__item others-color">
        <a-checkbox :value="0">
          <div class="list__item-content">
            <span class="list__label">
              Otros

              <a-tooltip
                title="El usuario no se encuentra disponible. Esta en estado: ocupado, refrigerio, en servicios o en capacitación."
              >
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
            <span class="list__value"> {{ data.others || 0 }} </span>
          </div>
        </a-checkbox>
      </li>
    </ul>
  </a-checkbox-group>
</template>

<script>
import { inject } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { EventManagement } from "@/app/shared/utils/enums";

export default {
  components: {
    InfoCircleOutlined,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
    progressive: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const selectedAgentsStates = inject("selectedAgentsStates");

    return {
      EventManagement,
      selectedAgentsStates,
    };
  },
};
</script>

<style lang="sass" scoped>
@mixin after-body
  content: ""
  position: absolute
  height: 100%
  width: 8px
  top: 0
  left: 0
  border-radius: 8px 0 0 8px

p
  margin: 0
  color: $gray-8

.list
  padding: 0
  list-style: none
  width: 100%
  margin: 0

  &__item
    margin: 6px
    height: 40px
    background-color: $geekblue-1
    border-radius: 8px
    padding: 7px 24px
    position: relative

    &.waiting-color::after
      @include after-body
      background-color: $cyan-4

    &.ringing-color::after
      @include after-body
      background-color: $blue-4

    &.talking-color::after
      @include after-body
      background-color: $green-4

    &.acw-color::after
      @include after-body
      background-color: $orange-4

    &.others-color::after
      @include after-body
      background-color: $volcano-3

    &-content
      display: flex
      align-items: center
      justify-content: space-between

  &__label
    font-size: $font-small

  &__value
    color: $gray-8
    font-weight: 600
    font-size: 16px

:deep(span.ant-checkbox)
  margin-top: -7px

:deep(.ant-checkbox-wrapper)
  display: flex !important
  align-items: center !important

:deep(.ant-checkbox + span)
  width: 100% !important
</style>

<style>
.dashboard-checkbox-list.ant-checkbox-group {
  width: 100% !important;
}
</style>
